import React from 'react';
import { useBranding } from '../../hooks/useBranding';
import { HugDiscountHeroBadge } from './hug-discount/HugDiscountHeroBadge';
import SaveInstallationBadge from './save-installation/SaveInstallationBadge';

export const HeroBadge: React.FC = () => {
  const branding = useBranding();

  if (branding === 'hug') {
    return <HugDiscountHeroBadge imageSize={{ width: 230, height: 220 }} />; // Adjust the size as needed
  }

  return (
    <SaveInstallationBadge
      imageSize={{ width: 290, height: 300 }}
      illustrationSize={{ width: 62, height: 68 }}
    />
  );
};
